// extracted by mini-css-extract-plugin
export default {"cardTopics":"review_cardTopics__18HVO","cardValues":"review_cardValues__sSWz7","subTopicDivider":"review_subTopicDivider__WDutL"};